import { AppConfigService, BlogService, GhStorageService, SocialShareService, TrackingService } from '@core/services';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

const providers = [
  AppConfigService,
  BlogService,
  GhStorageService,
  SocialShareService,
  TrackingService,
];
/**
 * The ServicesModule is a singleton
 * Should not be imported in by other module than the app.module
 * Hence the guard
 */
@NgModule({ exports: [
        CommonModule
    ], imports: [CommonModule], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class ServicesModule {
  static forRoot(): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ServicesModule) {
    if (parentModule) { // guard
      throw new Error('ServicesModule is already loaded. Import it in the AppModule only');
    }
  }

}
